import { useMemo } from 'react';

import { useNow } from '@change-corgi/core-react/date';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useMembershipModalState } from '../../../../../modalContext';

import { useAverageAmountExperimentMessage } from './useAverageAmountExperimentMessage';

type Result = {
	yes: {
		label: string;
		message: string;
		highlight: string;
	};
	no: {
		label: string;
		message: string;
	};
};

export function useCopy(): Result {
	const [{ useDonationLanguage, revenuePpmuDayZeroExperiment }] = useMembershipModalState();
	const { translate, localizeDate } = useI18n();
	const getAverageAmountMessage = useAverageAmountExperimentMessage();

	const suffix = useDonationLanguage ? '_donation' : '';

	const now = useNow();

	const trialDays = revenuePpmuDayZeroExperiment?.variation === 'variant_1' ? 0 : 30;

	const startDate = useMemo(
		() => localizeDate(new Date(now.getTime() + trialDays * 24 * 60 * 60 * 1000), 'date', 'long'),
		[localizeDate, now, trialDays],
	);

	return {
		yes: {
			label: translate('corgi.co.ppmu.modal.selection_yes_heading'),
			message:
				getAverageAmountMessage(startDate) || translate('corgi.co.ppmu.modal.selection_yes_message', { startDate }),
			highlight: translate('corgi.co.ppmu.modal.highlight_text'),
		},
		no: {
			label: translate('corgi.co.ppmu.modal.no_title'),
			message: translate(`corgi.co.ppmu.modal.no_description${suffix}`),
		},
	};
}
